import style from './CropBadge.module.css';

export const CropBadge = ({ id, health, addClassName, children, ...rest }) => <div
  className={`${style.cropBadge} ${style[id.toLowerCase()] ?? ""} ${addClassName}`}
  {...rest} >
  {id.toUpperCase()[0]}
  {children}
</div>;
